(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["freshness-card"] && !Shopify.designMode) return;
  try {
    if (!window.__freshnessCardCartBound) {
    window.__freshnessCardCartBound = true;

    const updateCartCount = (itemCount) => {
      const cartLink = document.querySelector('.site-header__cart');
      if (!cartLink) return;

      let countEl = cartLink.querySelector('.site-header__cart-count');

      if (itemCount > 0) {
        if (!countEl) {
          countEl = document.createElement('span');
          countEl.className = 'site-header__cart-count';
          cartLink.appendChild(countEl);
        }

        countEl.textContent = itemCount;
      } else if (countEl) {
        countEl.remove();
      }
    };

    const updateFreshnessCardButton = async (card) => {
      if (!card || !window.SandyInventory) return;

      const button = card.querySelector('[data-freshness-add-button]');
      if (!button) return;

      if (!button.dataset.defaultLabel) {
        button.dataset.defaultLabel = button.textContent.trim();
      }

      const variant = SandyInventory.getVariantFromDataset(card);
      if (!variant?.id) return;

      const cart = await SandyInventory.fetchCart();
      const inCart = SandyInventory.getCartQuantityForVariant(cart, variant.id);
      const maxAdd = SandyInventory.getMaxAddQuantity(variant, inCart);

      if (!variant.available) {
        button.disabled = true;
        button.textContent = button.dataset.soldOutLabel || 'Sold out';
        return;
      }

      if (maxAdd !== null && maxAdd < 1) {
        button.disabled = true;
        button.textContent = button.dataset.maxQuantityLabel || button.dataset.soldOutLabel || 'Sold out';
        return;
      }

      button.disabled = false;
      button.textContent = button.dataset.defaultLabel;
    };

    const updateAllFreshnessCards = () => {
      document.querySelectorAll('.freshness-card[data-variant-id]').forEach((card) => {
        updateFreshnessCardButton(card);
      });
    };

    const initFreshnessCards = () => {
      document.querySelectorAll('.freshness-card[data-variant-id]').forEach((card) => {
        const button = card.querySelector('[data-freshness-add-button]');
        if (button && !button.dataset.defaultLabel) {
          button.dataset.defaultLabel = button.textContent.trim();
        }
      });

      updateAllFreshnessCards();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFreshnessCards);
    } else {
      initFreshnessCards();
    }

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-freshness-add]');
      if (!form) return;

      event.preventDefault();

      const card = form.closest('.freshness-card');
      const button = form.querySelector('[data-freshness-add-button]');
      if (!button || button.disabled) return;

      if (window.SandyInventory && card) {
        const variant = SandyInventory.getVariantFromDataset(card);
        const cart = await SandyInventory.fetchCart(true);
        const inCart = SandyInventory.getCartQuantityForVariant(cart, variant.id);
        const maxAdd = SandyInventory.getMaxAddQuantity(variant, inCart);

        if (maxAdd !== null && maxAdd < 1) {
          await updateFreshnessCardButton(card);
          return;
        }
      }

      const defaultLabel = button.dataset.defaultLabel || button.textContent;
      button.disabled = true;

      try {
        const cartAddUrl = window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart/add.js`
          : '/cart/add.js';
        const cartUrl = window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart.js` : '/cart.js';

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: new FormData(form),
        });

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        SandyInventory?.invalidateCart();

        const cartResponse = await fetch(cartUrl, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateCartCount(cart.item_count);
        }

        button.textContent = button.dataset.addedLabel || 'Added';
        window.setTimeout(() => {
          updateAllFreshnessCards();
        }, 1800);
      } catch (error) {
        button.textContent = defaultLabel;
        await updateFreshnessCardButton(card);
        form.submit();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inventory-limits"] && !Shopify.designMode) return;
  try {
    if (!window.SandyInventory) {
    window.SandyInventory = (() => {
      let cartCache = null;

      const parseNumber = (value) => {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : 0;
      };

      const isTracked = (variant) => variant?.inventory_management === 'shopify';

      const allowsOversell = (variant) => variant?.inventory_policy === 'continue';

      const getStockQuantity = (variant) => parseNumber(variant?.inventory_quantity);

      const getCartQuantityForVariant = (cart, variantId) => {
        if (!cart?.items?.length) return 0;

        return cart.items
          .filter((item) => item.variant_id === variantId)
          .reduce((total, item) => total + item.quantity, 0);
      };

      const getMaxLineQuantity = (variant) => {
        if (!variant?.available) return 0;
        if (!isTracked(variant) || allowsOversell(variant)) return null;
        return Math.max(0, getStockQuantity(variant));
      };

      const getMaxAddQuantity = (variant, cartQuantity = 0) => {
        const maxLine = getMaxLineQuantity(variant);
        if (maxLine === null) return null;
        return Math.max(0, maxLine - cartQuantity);
      };

      const getVariantFromDataset = (element) => {
        if (!element) return null;

        return {
          id: parseNumber(element.dataset.variantId),
          available: element.dataset.variantAvailable !== 'false',
          inventory_management: element.dataset.inventoryManagement || null,
          inventory_policy: element.dataset.inventoryPolicy || 'deny',
          inventory_quantity: parseNumber(element.dataset.inventoryQuantity),
        };
      };

      const fetchCart = async (refresh = false) => {
        if (cartCache && !refresh) return cartCache;

        const cartUrl = window.Shopify?.routes?.root
          ? `${window.Shopify.routes.root}cart.js`
          : '/cart.js';

        const response = await fetch(cartUrl, {
          headers: {
            Accept: 'application/json',
          },
        });

        if (!response.ok) {
          throw new Error('Cart fetch failed');
        }

        cartCache = await response.json();
        return cartCache;
      };

      const invalidateCart = () => {
        cartCache = null;
      };

      const applyQuantityControls = ({ input, minusButton, plusButton, maxQuantity }) => {
        if (!input) return;

        const currentValue = parseNumber(input.value) || 1;
        const minValue = parseNumber(input.min) || 1;

        if (maxQuantity === null) {
          input.removeAttribute('max');
          if (plusButton) plusButton.disabled = false;
        } else {
          input.max = Math.max(minValue, maxQuantity);
          const clampedValue = Math.min(Math.max(currentValue, minValue), Math.max(minValue, maxQuantity));
          input.value = clampedValue;
          if (plusButton) plusButton.disabled = clampedValue >= maxQuantity;
        }

        if (minusButton) {
          minusButton.disabled = parseNumber(input.value) <= minValue;
        }
      };

      const canIncrease = (currentQuantity, maxQuantity) => {
        if (maxQuantity === null) return true;
        return currentQuantity < maxQuantity;
      };

      return {
        allowsOversell,
        applyQuantityControls,
        canIncrease,
        fetchCart,
        getCartQuantityForVariant,
        getMaxAddQuantity,
        getMaxLineQuantity,
        getStockQuantity,
        getVariantFromDataset,
        invalidateCart,
        isTracked,
        parseNumber,
      };
    })();
  }
  } catch(e) { console.error(e); }
})();

})();
